/* Glas-Kopf passt sich dem Untergrund an (24.10.2026).
   Liegt unter der Mitte des Kopfkastens ein dunkler Abschnitt, bekommt header-component die
   Klasse rxk-kopf-dunkel (dunkles Glas, helle Schrift). Gemessen wird die erste deckende
   Hintergrundfarbe unter dem Kasten; Bilder/Videos zählen als dunkel, wenn ihr Abschnitt dunkel ist. */
(function () {
  var kopf = document.querySelector('header-component'); if (!kopf) return;
  var kasten = kopf.querySelector('.header__columns') || kopf;
  function hell(rgb) {
    var m = rgb && rgb.match(/[\d.]+/g); if (!m) return null;
    if (m.length > 3 && +m[3] < 0.5) return null; // durchsichtig: weiter nach oben
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
  }
  function untergrund(x, y) {
    var liste = document.elementsFromPoint(x, y);
    for (var i = 0; i < liste.length; i++) {
      var e = liste[i];
      if (kopf.contains(e) || e.closest('.shopify-section-group-header-group')) continue;
      for (var n = e; n && n !== document.documentElement; n = n.parentElement) {
        var l = hell(getComputedStyle(n).backgroundColor);
        if (l !== null) return l;
      }
      return 1;
    }
    return 1;
  }
  var wartet = false;
  function pruefen() {
    wartet = false;
    if (document.querySelector('header-menu[aria-expanded="true"]')) return; // offenes Menü bleibt hell
    var r = kasten.getBoundingClientRect(), y = r.top + r.height / 2;
    var w = [0.2, 0.5, 0.8].map(function (f) { return untergrund(r.left + r.width * f, y); });
    var dunkel = w.filter(function (l) { return l < 0.35; }).length >= 2;
    kopf.classList.toggle('rxk-kopf-dunkel', dunkel);
  }
  function bald() { if (!wartet) { wartet = true; requestAnimationFrame(pruefen); } }
  document.addEventListener('scroll', bald, { passive: true, capture: true }); // capture: gescrollt wird teils in einem inneren Bereich
  addEventListener('resize', bald);
  addEventListener('load', bald);
  new MutationObserver(bald).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: false });
  bald();

  /* Geräte-Zeile im Shop-Menü (snippets/rxk-menu-text-links.liquid) befüllen: gemerktes Gerät oder Finder. */
  function geraeteZeile() {
    function lies(s, k) { try { return JSON.parse(s.getItem(k)); } catch (e) { return null; } }
    var d = lies(sessionStorage, 'rxk-geraete-gast') || lies(localStorage, 'rxk-geraete') || {};
    var akt = d.aktiv && typeof d.aktiv === 'object' ? Object.values(d.aktiv).filter(Boolean)[0] : '';
    var g = akt || (Array.isArray(d.geraete) ? d.geraete[0] : '');
    document.querySelectorAll('[data-rxk-menu-geraet]').forEach(function (a) {
      if (g) { a.textContent = a.dataset.text.replace('__G__', g) + ' →'; a.href = a.getAttribute('data-shop') || a.href; }
      else { if (!a.getAttribute('data-shop')) a.setAttribute('data-shop', a.getAttribute('href')); a.textContent = a.dataset.finderText.replace(/\s*→\s*$/, '') + ' →'; a.href = a.dataset.finder; }
      a.hidden = false;
    });
  }
  geraeteZeile();
  kopf.addEventListener('pointerenter', geraeteZeile);
  kopf.addEventListener('focusin', geraeteZeile);
})();
